module.exports = "<div class=\"fn-block\"><ng-transclude></ng-transclude></div>";